/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Routemize_DTOs_CompanySettingsDTO } from '../models/Routemize_DTOs_CompanySettingsDTO';
import type { Routemize_DTOs_CreateUpdateCompanySettingsDTO } from '../models/Routemize_DTOs_CreateUpdateCompanySettingsDTO';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CompanySettingsService {
    /**
     * @param requestBody
     * @returns Routemize_DTOs_CompanySettingsDTO OK
     * @throws ApiError
     */
    public static postApiAppCompanySettingsCreate(
        requestBody?: Routemize_DTOs_CreateUpdateCompanySettingsDTO,
    ): CancelablePromise<Routemize_DTOs_CompanySettingsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/companySettings/create',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_CompanySettingsDTO OK
     * @throws ApiError
     */
    public static getApiAppCompanySettingsGet(): CancelablePromise<Routemize_DTOs_CompanySettingsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/app/companySettings/get',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns Routemize_DTOs_CompanySettingsDTO OK
     * @throws ApiError
     */
    public static putApiAppCompanySettingsUpdate(
        id: string,
        requestBody?: Routemize_DTOs_CreateUpdateCompanySettingsDTO,
    ): CancelablePromise<Routemize_DTOs_CompanySettingsDTO> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/app/companySettings/{id}/update',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Routemize_DTOs_CompanySettingsDTO OK
     * @throws ApiError
     */
    public static postApiAppCompanySettingsRefreshGoogleReviews(): CancelablePromise<Routemize_DTOs_CompanySettingsDTO> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/app/companySettings/refreshGoogleReviews',
        });
    }
}
